export const DATAHUB_API_URL = process.env.REACT_APP_DATAHUB_API_URL || 'https://api.stock-pro.net/datahub/'
export const DOCHUB_API_URL = process.env.REACT_APP_DOCHUB_API_URL || 'https://api.stock-pro.net/dochub'
